import React from "react";
import { Pagination } from "@mui/material";

const GeneralFooter = ({
  pagination,
  handlePageChange,
  handlePageSizeChange,
  dataLength,
}) => {
  const currentPage = pagination.currentPage || pagination.current_page || 1;
  const pageSize = pagination.pageSize || pagination.per_page || 10;
  const totalItems = pagination.totalItems || pagination.total_records || 0;
  const totalPages = pagination.totalPages || pagination.total_pages || 1;

  return (
    <div className="flex md:flex-row flex-col justify-between items-center mt-4 w-full">
      <div className="text-[14px] text-[#212529] my-2">
        {dataLength > 0 ? (
          <span>
            Showing <strong>{(currentPage - 1) * pageSize + 1}</strong> to{" "}
            <strong>{Math.min(currentPage * pageSize, totalItems)}</strong> of{" "}
            <strong>{totalItems}</strong> entries
          </span>
        ) : (
          <span>Showing 0 to 0 of 0 entries</span>
        )}
      </div>

      {/* Right Side: Entries Per Page + Pagination */}
      <div className="flex items-center gap-4">
        {/* Entries per page dropdown (if you want it back) */}
        {/* <PaginationDropdown
          value={pageSize}
          onChange={handlePageSizeChange}
          options={[
            { value: 10, label: "10" },
            { value: 20, label: "20" },
            { value: 30, label: "30" },
            { value: 50, label: "50" },
          ]}
        /> */}

        {/* Pagination */}
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          shape="rounded"
          sx={{
            "& .Mui-selected": {
              backgroundColor: "none",
              color: "#137e81",
              borderBottom: "2px solid #137e81",
              "&:hover": {
                color: "#fff",
                backgroundColor: "#137e81",
              },
            },
          }}
        />
      </div>
    </div>
  );
};

export default GeneralFooter;
